import Slider from 'react-slick';
import styles from './websiteContent.module.scss';
import {
  websiteProject,
  BlockChain,
  sale,
  videoCall,
  fulfill,
  SlideArrowLeft,
  SlideArrowRight,
} from '../../image';
// import components
import SlideItem from '../slide-item/slideItem';
import ContentVideo from '../content-video';
import ContentText from '../content-text';
import { useEffect, useState } from 'react';
import web from '../../apis/web';
import { useHistory } from 'react-router-dom';
export default function WebsiteContent(props) {
  const [webData, setWebData] = useState([]);
  const [displayData, setDisplayData] = useState(0);
  const history = useHistory();
  //slide setting
  const SlickArrowLeft = ({ className, style, onClick }) => (
    <button
      className={`${className} ${styles['left__arrow']} ${styles['clear__button']}`}
      style={{
        fontSize: '40px',
        zIndex: '1',
        height: '40px',
        width: '40px',
        opacity: '1',
        color: 'White',
      }}
      onClick={onClick}
    >
      <SlideArrowLeft />
    </button>
  );
  const SlickArrowRight = ({ className, onClick }) => (
    <button
      className={`${className} ${styles['right__arrow']} ${styles['clear__button']}`}
      style={{
        fontSize: '40px',
        zIndex: '1',
        height: '40px',
        width: '40px',
        opacity: '1',
        color: 'White',
      }}
      onClick={onClick}
    >
      <SlideArrowRight />
    </button>
  );
  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    slidesToShow: 3,
    slidesToScroll: 1,
  };
  //slide item content
  const slideContent = [
    {
      src: BlockChain,
    },
    {
      src: sale,
    },
    {
      src: fulfill,
    },
    {
      src: sale,
    },
  ];

  const btnCallback = () => {
    window.location.href = webData[displayData].linkWeb;
  };

  useEffect(() => {
    web
      .getContent()
      .then((res) => {
        setWebData(res.data);
      })
      .catch((e) => console.log(e));
  }, []);
  return (
    <>
      <div className={styles['website']}>
        <div className={styles['website-main-content']}>
          <ContentText
            title={webData[displayData] && webData[displayData].title}
            content={webData[displayData] && webData[displayData].content}
            btnText="TRUY CẬP WEBSITE"
            btnCallback={btnCallback}
          />
          <div data-aos="fade-up" data-aos-duration="2000">
            <ContentVideo
              imageCover={websiteProject}
              video={videoCall}
              id="websiteVideo"
              coverClass="websiteCover"
            />
          </div>
        </div>
        <div className={styles['product-slide']}>
          <div
            data-aos="fade-left"
            data-aos-duration="2000"
            data-aos-delay="1000"
          >
            <div className={styles['slide-items']}>
              <Slider {...settings}>
                {webData.map((val, index) => (
                  <SlideItem
                    src={val.imgSlide}
                    number={index + 1}
                    display={setDisplayData}
                  />
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
